<div class="translateButton">
    <mat-icon class="example-icon text-cyan-700 cursor-pointer" aria-hidden="false" matTooltip="Translate" i18n-tooltip="Translate" svgIcon="mat_solid:translate"></mat-icon>
</div>